var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"controls":_vm.controls,"id":`videoStream${_vm.playerId}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }